module.exports = __webpack_public_path__ + "img/075d27c2668cc470656edb5fc5bf4695.png";